import { PopupMovedToDraftComponent } from './popup-moved-to-draft.component';

export const PopupMovedToDraftModule = angular
  .module('sfMobile.components.popup-moved-to-draft', [])
  .component('sfPopupMovedToDraft', PopupMovedToDraftComponent).name;
